"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Offline_1 = require("./Offline");
exports.default = Offline_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Offline/index.js
// module id = 212
// module chunks = 0 1